import { Base2Presenter } from "core/presenter";
import Moment from "moment";
import { NewSaleReportRepository } from "core/repository";

class DashboardPresenter extends Base2Presenter {
  initialState() {
    const urlParams = new URLSearchParams(window.location.hash);
    const startDate = Moment(urlParams.get("inicio"), "DD-MM-YYYY");
    const endDate = Moment(urlParams.get("fim"), "DD-MM-YYYY");
    return {
      loading: true,
      filters: {
        dateFrom: startDate.isValid()
          ? startDate
          : Moment()
              .startOf("day")
              .subtract(7, "days"),
        dateTo: endDate.isValid() ? endDate : Moment().endOf("day")
      },
      currentUser: {},
      results: [],
      dataGraph: {}
    };
  }

  async onStart() {
    this.load();
  }

  formatGraph(result) {
    let faturamento = {};
    let desconto = {};
    let custos = {};
    let lucro = {};
    result.data.graph.forEach(item => {
      const date = item._id;
      faturamento[date] = item.sell_value / 100;
      desconto[date] = item.discount / 100;
      custos[date] = item.cost_value / 100;
      lucro[date] = item.profit_value / 100;
    });
    let graphData = [
      { name: "Faturamento Total", data: faturamento },
      { name: "Desconto", data: desconto },
      { name: "Custos", data: custos },
      { name: "Lucro", data: lucro }
    ];
    return graphData;
  }

  onOpenSalesReport() {
    this.navigateTo("app.management.sales-report");
  }

  async load() {
    this.renewCancelToken();
    this.enqueue(() => ({
      loading: true,
      results: [],
      dataGraph: []
    }));
    const filters = await this.getFilters();
    const results = await NewSaleReportRepository.getDashBoardReports(filters);
    if (results.success) {
      const dataGraph = this.formatGraph(results);
      this.enqueue(() => ({
        results: results.data,
        dataGraph: dataGraph
      }));
    } else {
      this.sendNotification({
        type: "error",
        title: "Oops...",
        content:
          "Não foi possível buscar as informações. Por favor, tente novamente mais tarde ou entre em contato com o suporte."
      });
    }
    this.enqueue(() => ({
      loading: false
    }));
  }

  async getFilters() {
    const currentUser = await this.mRuntime.get("currentUser");
    const { dateFrom, dateTo } = this.viewModel.filters;

    return {
      company_uuid: currentUser.company_uuid,
      from: dateFrom.startOf("day").toISOString(),
      to: dateTo.endOf("day").toISOString()
    };
  }

  onFilterChange(filters) {
    window.location.hash = `?&inicio=${Moment(filters.dateFrom).format(
      "DD-MM-YYYY"
    )}&fim=${Moment(filters.dateTo).format("DD-MM-YYYY")}`;
    for (const key in filters) {
      if (filters[key] !== this.viewModel.filters[key]) {
        this.enqueue(vm => ({
          filters: { ...vm.filters, ...filters }
        }));
        break;
      }
    }
    this.load();
  }
}

export default DashboardPresenter;



// WEBPACK FOOTER //
// ./src/components/app/history/dashboard/presenter.js